import * as v from 'valibot';
import type { FieldDefinition } from '@v2/components/SchemaForm/types';

export const createPimsConfigSchema = v.object({
  key: v.pipe(v.string(), v.minLength(1, 'Key is required')),
  value: v.optional(v.string(), ''),
});

export type CreatePimsConfigFormValues = v.InferOutput<typeof createPimsConfigSchema>;

export const createPimsConfigFields: FieldDefinition[] = [
  { name: 'key', label: 'Key', type: 'text', placeholder: 'Configuration key' },
  {
    name: 'value',
    label: 'Value',
    type: 'text',
    placeholder: 'Configuration value (optional)',
    required: false,
  },
];
